import { Option } from 'components/Select/types';
import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import { FormContext } from '../FormContext';
import { handleValidation, ValidatorRule } from '../validation';
declare var TomSelect: any;

export type NAUMultiSelectProps = {
  id: string;
  label: string;
  description?: React.ReactNode;
  options: Option[];
  value?: string | number | string[];
  defaultValue?: string | number | string[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  validators?: ValidatorRule[];
  disabled?: boolean;
  placeholder?: string;
  name?: string;
};

const NAUMultiSelect: FC<NAUMultiSelectProps> = ({
  id,
  label,
  description,
  options,
  value,
  defaultValue,
  onChange,
  validators,
  disabled = false,
  name,
}) => {
  const selectRef = useRef<HTMLSelectElement>(null);
  const [lastValue, setLastValue] = useState<string | number | string[]>(
    value || defaultValue || [],
  );
  const [errorMessage, setErrorMessage] = useState('');
  const { registerInput, setInputError, registerValidation } =
    useContext(FormContext);

  // Register input and validation
  useEffect(() => {
    registerInput(label, selectRef);

    if (validators) {
      registerValidation(label, () => {
        if (disabled) return true;

        return handleValidation(
          selectRef.current?.value || '',
          validators,
          setErrorMessage,
          setInputError,
          label,
        );
      });
    }
  }, []);

  // Initialize TomSelect and handle value changes
  useEffect(() => {
    const initializeTomSelect = () => {
      const el = document.getElementById(id);

      if (!(el as any)?.tomselect) {
        TomSelect &&
          new TomSelect(el, {
            plugins: ['remove_button'],
            controlInput: '<input>',
            maxItems: null,
            dropdownContentClass: 'dropdown-menu show w-100',
            optionClass: 'dropdown-item',
            valueField: 'value',
            labelField: 'label',
            searchField: 'label',
            options: options,
            create: false,

          });
      }

      // Get the initialized element
      const tomSelectEl = document.getElementById(id);

      // Only clear and re-add items if value has changed
      if (JSON.stringify(lastValue) !== JSON.stringify(value)) {
        (tomSelectEl as any).tomselect.clear(true);
        (tomSelectEl as any).tomselect.addOptions(options);
        (tomSelectEl as any).tomselect.addItems(value);
        setLastValue(value);
      } else {
        // Just update options without clearing selection
        (tomSelectEl as any).tomselect.addOptions(options);
      }
    };

    // Small delay to ensure DOM is ready
    setTimeout(initializeTomSelect, 100);
  }, [id, options, value, lastValue]);

  // Handle select change with validation
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e);

    // if (validators) {
    //   handleValidation(
    //     e.target.value,
    //     validators,
    //     setErrorMessage,
    //     setInputError,
    //     label,
    //   );
    // }
  };

  return (
    <div>
      {!!label?.length && (
        <label htmlFor={label} className="form-label">
          {label}
        </label>
      )}

      {description && <div className="form-help">{description}</div>}

      <select
        id={id}
        disabled={disabled}
        className={`form-select ${errorMessage ? 'is-invalid' : ''}`}
        multiple
        value={Array.isArray(value || defaultValue) ? (value || defaultValue) : []}
        onChange={handleSelectChange}
        ref={selectRef}
        name={name}
      ></select>

      {errorMessage && <div className="invalid-feedback">{errorMessage}</div>}
    </div>
  );
};

export default NAUMultiSelect;
